export const useHaltPropagation = (e?: React.MouseEvent) => {
    e?.preventDefault();
    e?.stopPropagation();
};
